/**
 * Force a single page refresh on initial load when the `website-v6` cookie is `true`.
 * Uses sessionStorage to ensure the refresh happens only once per session (avoids infinite loops).
 */
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) {
    // Skip if already refreshed this session
    if (sessionStorage.getItem('websiteV6Refreshed')) return;

    const websiteV6Value = document.cookie
      .split('; ')
      .find((row) => row.startsWith('website-v6='))
      ?.split('=')[1];

    if (websiteV6Value === 'true') {
      sessionStorage.setItem('websiteV6Refreshed', 'true');
      // Reload the target page (to.path) so the user lands on the page
      // they navigated to, not the page they were on before the reload.
      window.location.href = to.fullPath;
    }
  }
});
